export default __webpack_public_path__ + "static/media/gallery-illus.a740e024.svg";